import { Property } from '@/modules/core/gql/generated';

// This helper for calculate price drop for NPL property
// price drop in NPL has different meaning with special
// offer price drop, so response price drop wont be used
export const generatePriceDropNPL = ({
    auction,
    offer,
}: {
    auction: Property['auction'];
    offer: Property['price']['offer'];
}) => {
    if (!auction) return;

    const { auction_discount_price, auction_starting_price } = auction;

    if (!auction_starting_price || auction_starting_price <= offer) return;
    const discountPrice =
        auction_discount_price || auction_starting_price - offer;
    const percentage = (discountPrice / auction_starting_price) * 100;
    return {
        oldPrice: auction_starting_price,
        amountPrice: auction_discount_price,
        percentage: {
            formattedValue: `- ${Math.floor(percentage)}%`,
            label: '',
            name: '',
            value: '',
        },
        shortText: `Hemat ${convertToIndonesianFormat(discountPrice)}`,
    };
};

export const convertToIndonesianFormat = (
    number: number,
    isRoundingDown?: boolean,
) => {
    if (number >= 1000000000) {
        if (isRoundingDown)
            return `${Math.floor(number / 1000000000)} Miliaran`;
        return `${number / 1000000000} Miliaran`;
    }
    if (number >= 1000000) {
        if (isRoundingDown) return `${Math.floor(number / 1000000)} Jutaan`;
        return `${number / 1000000} Jutaan`;
    }
    if (number >= 1000) {
        if (isRoundingDown) return `${Math.floor(number / 1000)} Ribuan`;
        return `${number / 1000} Ribuan`;
    }

    return `${number}`;
};
